/**
 * DEV-2069 («Воронка v2»). Обязательные поля карточки клиента у этапа воронки.
 *
 * Отдельным модулем, как documentTypes: строки нужны конструктору воронки,
 * карточке сделки и модалке блокировки перехода, а общий ru.ts правят несколько
 * эпиков сразу.
 *
 * Названий самих полей здесь нет и быть не должно: реестр живёт в client-data и
 * приезжает уже локализованным — вторая копия разъехалась бы на первом же новом
 * поле.
 */

// Конструктор воронки: блок требований в строке этапа и модалка выбора.
const ruConstructor = {
  requiredClientFields: 'Обязательные поля клиента',
  addClientField: 'Добавить поле',
  clientFieldsCount: '{n} поле клиента | {n} поля клиента | {n} полей клиента',
  fieldPickerTitle: 'Обязательные поля клиента',
  fieldPickerEmpty: 'Справочник полей не загрузился — обновите страницу',
  fieldPickerHint:
    'Этап «{name}» · сделка не уйдёт на него, пока выбранные поля не заполнены в карточке',
  unknownClientField: 'Поле больше не доступно',
}

const enConstructor = {
  requiredClientFields: 'Required client fields',
  addClientField: 'Add field',
  clientFieldsCount: '{n} client field | {n} client fields',
  fieldPickerTitle: 'Required client fields',
  fieldPickerEmpty: 'The field list failed to load — reload the page',
  fieldPickerHint:
    'Stage “{name}” · a deal will not move here until the chosen fields are filled in on the card',
  unknownClientField: 'Field is no longer available',
}

const vnConstructor = {
  requiredClientFields: 'Trường bắt buộc của khách hàng',
  addClientField: 'Thêm trường',
  clientFieldsCount: '{n} trường khách hàng',
  fieldPickerTitle: 'Trường khách hàng bắt buộc',
  fieldPickerEmpty: 'Không tải được danh mục trường — hãy tải lại trang',
  fieldPickerHint:
    'Giai đoạn «{name}» · giao dịch chưa chuyển sang nếu các trường đã chọn còn trống',
  unknownClientField: 'Trường không còn khả dụng',
}

// Модалка блокировки перехода: третий список рядом с задачами и документами.
const ruBlocked = {
  headingClientFields: 'Сначала заполните карточку клиента',
  bodyClientFields: 'Чтобы перевести сделку на этап «{stage}», в карточке клиента не хватает:',
  headingMixed: 'Переход заблокирован',
  bodyMixed: 'Чтобы перевести сделку на этап «{stage}», осталось:',
  openClient: 'К карточке клиента',
  fieldReason: 'не заполнено',
}

const enBlocked = {
  headingClientFields: 'Fill in the client card first',
  bodyClientFields: 'To move the deal to “{stage}”, the client card is missing:',
  headingMixed: 'The move is blocked',
  bodyMixed: 'To move the deal to “{stage}”, what is left:',
  openClient: 'Go to client card',
  fieldReason: 'not filled in',
}

const vnBlocked = {
  headingClientFields: 'Hãy điền hồ sơ khách hàng trước',
  bodyClientFields: 'Để chuyển giao dịch sang «{stage}», hồ sơ khách hàng còn thiếu:',
  headingMixed: 'Việc chuyển bị chặn',
  bodyMixed: 'Để chuyển giao dịch sang «{stage}», còn lại:',
  openClient: 'Tới hồ sơ khách hàng',
  fieldReason: 'chưa điền',
}

// Карточка сделки: плашка у блока клиента и строка баннера блокировки.
const ruDeal = {
  title: 'Для перехода на «{stage}» заполните',
  openCard: 'Открыть карточку клиента',
  allFilled: 'Данные клиента для следующего этапа заполнены',
  line: 'Данные клиента: {done} / {total} заполнено',
  fill: 'заполните {n} поле клиента | заполните {n} поля клиента | заполните {n} полей клиента',
}

const enDeal = {
  title: 'To move to “{stage}”, fill in',
  openCard: 'Open client card',
  allFilled: 'The client data for the next stage is complete',
  line: 'Client data: {done} / {total} filled in',
  fill: 'fill in {n} client field | fill in {n} client fields',
}

const vnDeal = {
  title: 'Để chuyển sang «{stage}», hãy điền',
  openCard: 'Mở hồ sơ khách hàng',
  allFilled: 'Dữ liệu khách hàng cho giai đoạn tiếp theo đã đủ',
  line: 'Dữ liệu khách hàng: đã điền {done} / {total}',
  fill: 'hãy điền {n} trường khách hàng',
}

export const stageClientFieldsMessages = {
  ru: {
    deals: { detail: { clientFields: ruDeal } },
    pipeline: { constructor: ruConstructor, blocked: ruBlocked },
  },
  en: {
    deals: { detail: { clientFields: enDeal } },
    pipeline: { constructor: enConstructor, blocked: enBlocked },
  },
  vn: {
    deals: { detail: { clientFields: vnDeal } },
    pipeline: { constructor: vnConstructor, blocked: vnBlocked },
  },
}
